import React, { useMemo, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import WelcomeMessage from 'src/views/dashboards/WelcomeMessage';
import DashboardDateFilter from 'src/views/dashboards/DashboardDateFilter';
import { useAccountConfiguration } from 'src/@core/hooks/useAccountConfiguration';
import { Stack } from '@mui/material';
import CustomDashboard from 'src/views/dashboards/customDashboard';
import DashboardOrderBySelect from 'src/views/dashboards/DashboardOrderBySelect';
import { calculateRange } from 'src/@core/utils/getDateRange';
import { endOfDay, format, startOfDay } from 'date-fns';

function getInitialOrderByValue(loggedInUserId: string): string {
  if (!loggedInUserId) return '';
  const col = localStorage.getItem(`ordercolumn-dashboard-${loggedInUserId}`)?.replace(/["]/g, '') ?? '0';
  switch (col) {
    case '1':
      return 'collectionDateTime';
    case '2':
      return 'orderDate';
    default:
      return 'deliveryDateTime';
  }
}

function getInitialDateFilterStrings(loggedInUserId: string): string[][] {
  if (!loggedInUserId) return [[''], ['']];
  const selectedRange = localStorage.getItem(`daterange-dashboard-${loggedInUserId}`)?.replace(/["]/g, '') ?? 'Today';
  const { dateFrom, dateTo } = calculateRange(selectedRange, '');
  const from = startOfDay(new Date(dateFrom ?? new Date()));
  const to = endOfDay(new Date(dateTo ?? new Date()));
  if (isNaN(from.getTime()) || isNaN(to.getTime())) return [[''], ['']];

  return [
    [`ge datetime'${format(from, 'yyyy-MM-dd HH:mm:ss')}' and`],
    [`le datetime'${format(to, 'yyyy-MM-dd HH:mm:ss')}'`]
  ];
}

const ReactGridLayout = () => {
  const { user } = useAuth();
  const loggedInUserId = user?.profile.tenantUserId as string;

  const [dateFilterStrings, setDateFilterStrings] = useState<string[][]>(() => getInitialDateFilterStrings(loggedInUserId));
  const [orderByValue, setOrderByValue] = useState<string>(() => getInitialOrderByValue(loggedInUserId));

  const { configData } = useAccountConfiguration();

  const dashboardId = useMemo(() => configData?.dashboard?.dashboardId ?? '', [configData]);

  return (
    <>
      <Stack direction={{ xs: 'column', md: 'row' }} justifyContent={{ xs: 'flex-start', md: 'space-between' }}>
        <WelcomeMessage />

        <Stack
          direction="row"
          justifyContent={{ xs: 'flex-end', md: 'flex-start' }}
          alignItems={'center'}
          paddingRight="20px">
          <DashboardOrderBySelect
            onChange={setOrderByValue}
            widgetName={''}
          />
          <DashboardDateFilter onChange={setDateFilterStrings} />
        </Stack>
      </Stack>

      <CustomDashboard
        dashboardId={dashboardId}
        dateFilterStrings={dateFilterStrings}
        orderByValue={orderByValue}
        viewMode="view"
      />
    </>
  );
};

export default ReactGridLayout;
